<style lang="scss" scoped>
.search {
  width: 210px;
}
.bg {
  background: #fff;
  padding: 60px 30px;
}
.block {
  padding: 0 0 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}
.article {
  display: inline-block;
  border: 1px solid #dcdfe6;
  position: relative;
  text-align: left;
  width: 300px;
  cursor: pointer;
  padding-bottom: 10px;
  .title {
    padding: 0 10px;
    box-sizing: border-box;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
  }
  .desc {
    padding: 8px;
    line-height: 19px;
  }
  .img {
    width: 100%;
    height: 160px;
  }
  &.multi {
    .first {
      position: relative;
      .title {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        color: #fff;
        background: rgba(0, 0, 0, 0.7);
      }
    }
    .other {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #dcdfe6;
      padding: 15px 0;
      &:last-child {
        border: none;
      }
      .title {
        font-size: 14px;
        line-height: 20px;
        height: 60px;
      }
      .img {
        flex-shrink: 0;
        margin-right: 10px;
        margin-left: 10px;
        width: 80px;
        height: 80px;
      }
    }
  }
}
.link {
  display: inline-block;
  width: 400px;
  height: 108px;
  border: 1px solid #bdc7db;
  padding: 20px 15px;
  position: relative;
  .title {
    color: #000;
    font-size: 18px;
    margin-bottom: 15px;
  }
  .info {
    width: 240px;
  }
  .desc {
    font-size: 16px;
    color: #9a9a9a;
  }
  .img {
    position: absolute;
    bottom: 20px;
    right: 15px;
    width: 80px;
    height: 80px;
  }
}
.sound {
  vertical-align: middle;
  display: inline-block;
  padding: 15px 20px;
  width: 240px;
  .iconyuyin {
    font-size: 30px;
    color: #173bcf;
    font-size: 32px;
    line-height: 36px;
    cursor: pointer;
  }
}
.video {
  vertical-align: middle;
  display: inline-block;
  padding: 15px 20px;
  width: 240px;
  .el-icon-video-play {
    font-size: 30px;
    color: #173bcf;
    font-size: 32px;
    line-height: 36px;
    cursor: pointer;
  }
}
.text {
  color: #353535;
  overflow-y: auto;
  word-break: break-all;
  line-height: 20px;
  height: 40px;
  line-height: 40px;
  /deep/ .emoji {
    width: 26px;
    background: transparent !important;
    cursor: unset;
    vertical-align: -8px;
  }
}
</style>

<template>
  <div>
    <AlertTips />
    <div class="bg">
      <div class="clearfix mb20">
        <el-input placeholder="搜索关键词/规则名称" v-model="key" class="search">
          <i class="el-icon-search el-input__icon pointer" slot="suffix" @click="search"></i>
        </el-input>
        <router-link to="key/creat">
          <el-button type="primary" class="fr">添加回复</el-button>
        </router-link>
      </div>
      <el-table :data="data" style="width: 100%" ref="table">
        <el-table-column prop="name" label="规则名称" width="180"></el-table-column>
        <el-table-column label="关键词" width="180">
          <template slot-scope="scope">
            <div>
              {{scope.row.keywords.map(v=>{
              return v.keywords
              }).join(',')}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="回复内容">
          <template slot-scope="scope">
            <span v-for="(v,k) in scope.row.material" :key="k">
              <template v-if="k == 'TEXT'">文本 {{v}},</template>
              <template v-if="k == 'IMAGE'">图片 {{v}},</template>
              <template v-if="k == 'NEWS'">图文 {{v}},</template>
              <template v-if="k == 'OUT_LINK'">外链 {{v}},</template>
              <template v-if="k == 'VIDEO'">视频 {{v}},</template>
              <template v-if="k == 'VOICE'">音频 {{v}},</template>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="toogleExpand(scope.row)">详情</el-button>
            <router-link :to="{path:'key/edit',query:{id: scope.row.autoReplyId}}">
              <el-button type="text" size="mini">编辑</el-button>
            </router-link>
            <el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column type="expand" width="1">
          <template slot-scope="props">
            <el-form
              ref="form"
              :model="form"
              label-width="100px"
              label-position="left"
              class="addForm"
            >
              <el-form-item label="规则名称">
                <el-row>
                  <el-col :span="20">
                    <div>{{form.name}}</div>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="关键词">
                <span
                  v-for="(item,index) in form.keywords"
                  :key="index"
                >{{item.keywords}}({{item.match ? '全匹配' : '半匹配'}})</span>
              </el-form-item>
              <el-form-item label="回复内容">
                <template v-if="form.material.length">
                  <el-row v-for="(item,index) in form.material" :key="index">
                    <el-col :span="20">
                      <template v-if="item.type == 1">
                        <div class="block">
                          <div class="text" v-html="JSON.parse(item.content.text)[0]"></div>
                        </div>
                      </template>
                      <template v-if="item.type == 2">
                        <div class="block">
                          <el-image
                            class="border middle"
                            style="width: 182px; height: 122px"
                            :src="item.content.thumbUrl"
                            fit="contain"
                          ></el-image>
                        </div>
                      </template>
                      <template v-if="item.type == 3">
                        <div class="block">
                          <div class="article multi middle">
                            <template v-if="item.content.news.length>1">
                              <div v-for="(item2,index) in item.content.news" :key="index">
                                <template v-if="!index">
                                  <div class="first">
                                    <el-image :src="item2.thumbUrl" lazy fit="cover" class="img"></el-image>
                                    <div class="title line1">{{item2.title}}</div>
                                  </div>
                                </template>
                                <template v-else>
                                  <div class="other">
                                    <div class="title line3">{{item2.title}}</div>
                                    <el-image :src="item2.thumbUrl" lazy fit="cover" class="img"></el-image>
                                  </div>
                                </template>
                              </div>
                            </template>
                            <template v-else>
                              <div class="title line1">{{item.content.news[0].title}}</div>
                              <el-image
                                :src="item.content.news[0].thumbUrl"
                                lazy
                                fit="cover"
                                class="img"
                              ></el-image>
                              <div class="desc">{{item.content.news[0].digest}}</div>
                            </template>
                          </div>
                        </div>
                      </template>
                      <template v-if="item.type == 4">
                        <div class="block">
                          <div class="sound border line1">
                            <i class="iconfont iconyuyin middle mr10" @click="play(item.content)"></i>
                            <span>{{item.content.title}}</span>
                          </div>
                        </div>
                      </template>
                      <template v-if="item.type == 5">
                        <div class="block">
                          <div class="video border line1">
                            <i
                              class="iconfont el-icon-video-play middle mr10"
                              @click="playVideo(item.content.videoUrl)"
                            ></i>
                            <span>{{item.content.title}}</span>
                          </div>
                        </div>
                      </template>
                      <template v-if="item.type == 10">
                        <div class="block">
                          <div class="link">
                            <div class="info">
                              <div class="title line2">{{item.content.title }}</div>
                              <div class="desc line3">{{item.content.digest}}</div>
                            </div>
                            <img
                              :src="item.content.thumbUrl"
                              class="img"
                              v-if="item.content.thumbUrl"
                            />
                          </div>
                        </div>
                      </template>
                    </el-col>
                  </el-row>
                </template>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt40">
        <el-pagination
          class="pager"
          layout="prev, pager, next"
          :page-size="pageSize"
          :current-page.sync="page"
          :total="total"
          @current-change="changePage"
          hide-on-single-page
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import AlertTips from '@/components/alertTips';
export default {
  components: { AlertTips },
  computed: {},
  props: ['id'],
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      key: '',
      data: [],
      form: {
        name: '',
        replyRule: '',
        input: '',
        select: '',
        keywords: [
          {
            match: '',
            keywords: '',
          },
        ],
        material: [],
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async changePage(val) {
      await this.getData();
    },
    async getData(search) {
      let res = search
        ? await this.$http.get(
            `/api/${this.id}/autoreply/keywords?key=${this.key}&page=${this.page}&size=${this.pageSize}`,
          )
        : await this.$http.get(
            `/api/${this.id}/autoreply/keywords?page=${this.page}&size=${this.pageSize}`,
          );
      console.log(res);
      for (let i = 0; i < res.list.length; i++) {
        let material = res.list[i].material;
        res.list[i].material = {};
        for (let j = 0; j < material.length; j++) {
          res.list[i].material[material[j].replyTypeName]
            ? res.list[i].material[material[j].replyTypeName]++
            : (res.list[i].material[material[j].replyTypeName] = 1);
        }
      }
      this.data = res.list;
      this.total = res.totalSize;
    },
    async toogleExpand(row) {
      let res = await this.$http.get(
        `/api/${this.id}/autoreply/${row.autoReplyId}/keyword`,
      );
      console.log(res);
      this.form = res;
      let $table = this.$refs.table;
      this.data.map(item => {
        $table.toggleRowExpansion(item, false);
      });
      $table.toggleRowExpansion(row);
    },
    async del(row) {
      let res = await this.$confirm('确定删除此回复?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      if (res) {
        await this.$http.delete(
          `/api/${this.id}/autoreply/${row.autoReplyId}/keyword`,
        );
        this.$message.success('删除成功');
        this.getData();
      }
    },
    async search() {
      console.log(1);
      await this.getData(1);
    },
  },
};
</script>
